export default __webpack_public_path__ + "static/media/remixicon.5ddcd2c1.eot";